import {Injectable} from "@angular/core";
import {PerformanceTrackerFilterHelper} from "../../../utils/core/orderFilter/performance-tracker-filter-helper";
import {CombinedOrderElementDto} from "../../../models/core/combined-order-element-dto";
import {TimeRepository} from "../time/time-repository";
import {FilterVO} from "../../../../common/utils/filter/models/filter-vo";
import {EventAnalysisCollectionDto} from "../../../http/models/event-analysis-collection-dto";
import {RevenueCalculationMethod} from "../../../utils/revenue-calculation-method";
import {RevenueCalculationStrategy} from "../../../../common/enums/strategies/revenue-calculation-strategy";
import {CompositionTypeNl} from "../../../../../../models/composition-type/composition-type-nl";
import {TaxUtilities} from "../../../../../../utils/tax-utilities";
import {LinkedDtoRepository} from "../../../../common/repositories/linked-dto-repository";
import {MultiEventAnalysisEventDto} from "../../../models/core/multi-event-analysis-event-dto";
import {BookingType} from "../../../../../../models/payment/booking-type";
import {VATRate, VATRateHelper} from "../../../../../../models/common/vat-rate";


@Injectable({
  providedIn: 'root'
})
export class OrderRepository {
  filterHelper: PerformanceTrackerFilterHelper = new PerformanceTrackerFilterHelper()


  combinedOrderElements: CombinedOrderElementDto[] = []
  cachedCombinedOrderElements: CombinedOrderElementDto[] = []


  totalRevenue: number = 0
  totalRevenueAfterTax: number = 0
  totalQuantity: number = 0
  totalTaxes: number = 0

  constructor(private timeRepository: TimeRepository,
              private linkedDtoRepository: LinkedDtoRepository<any>,
  ) {

  }

  initialize(multiEventAnalysisEventDto: EventAnalysisCollectionDto[]) {
    this.parseListParseMultiEventAnalysisEventDto(multiEventAnalysisEventDto)
  }

  update() {
    this.filterHelper.applyFilter(this.combinedOrderElements, this.cachedCombinedOrderElements)

    // could be run in parallel
    this.totalQuantity = this.calculateTotalQuantity()
    this.totalRevenue = this.calculateTotalRevenue(RevenueCalculationMethod.fnMapping[RevenueCalculationStrategy.revenue])
    this.totalRevenueAfterTax = this.calculateTotalRevenue(RevenueCalculationMethod.fnMapping[RevenueCalculationStrategy.revenueExcludingTaxes])

    // ----
    this.totalTaxes = this.totalRevenue - this.totalRevenueAfterTax
  }

  calculateTotalQuantity() {
    return this.combinedOrderElements.reduce((acc, cur) => acc + cur.orderCount, 0)
  }

  calculateTotalRevenue(revenueFn: (combinedOrderElementDto: CombinedOrderElementDto) => number) {
    return this.combinedOrderElements.reduce((acc, cur) => acc + revenueFn(cur), 0)
  }

  getActiveOrderElements(): CombinedOrderElementDto[] {
    return this.combinedOrderElements
  }

  filter<T>(filter: FilterVO<T>, isActive: boolean) {
    if (isActive) {
      this.filterHelper.addFilter(filter)
    } else {
      this.filterHelper.removeFilter(filter)
    }
  }


  parseListParseMultiEventAnalysisEventDto(multiEventAnalysisEventsDto: MultiEventAnalysisEventDto[]) {
    this.cachedCombinedOrderElements = []
    this.combinedOrderElements = []
    for (let eventDto of multiEventAnalysisEventsDto) {
      this.parseMultiEventAnalysisEventDto(eventDto)
    }
  }

  parseMultiEventAnalysisEventDto(multiEventAnalysisEventDto: MultiEventAnalysisEventDto) {
    // Todo implement correctly
    let interval: string = this.timeRepository.toKey(multiEventAnalysisEventDto.eventDto.start, multiEventAnalysisEventDto.eventDto.id)

    let eventId: string = multiEventAnalysisEventDto.eventDto.id
    for (let _eventAnalysisBaseDto of multiEventAnalysisEventDto.eventAnalysisBaseDtoList) {
      let bookingType: BookingType = _eventAnalysisBaseDto.bookingType
      let orderCount: number = _eventAnalysisBaseDto.orderCount
      let revenue: number = _eventAnalysisBaseDto.revenue
      let locationId: string = _eventAnalysisBaseDto.locationId
      let compositionTypeId: string = _eventAnalysisBaseDto.compositionTypeId ?? ""
      let taxRate: number = VATRateHelper.GetValueOrDefault((this.linkedDtoRepository.getMapping("compositionTypeId")[compositionTypeId]! as CompositionTypeNl)?.vatRate ?? VATRate.NORMAL)
      let revenueAfterTax: number = TaxUtilities.getNetFromGross(_eventAnalysisBaseDto.revenue, taxRate)

      let combinedOrderElementDto = new CombinedOrderElementDto(eventId, interval, bookingType, orderCount, revenue, locationId, compositionTypeId)
      combinedOrderElementDto.revenueAfterTax = revenueAfterTax
      this.combinedOrderElements.push(combinedOrderElementDto)
    }
  }
}
